import { PREVENTIVI, PREVENTIVI_FILTERED, DELETE_PREVENTIVO, SEND_MAIL_PREVENTIVO, DUPLICATE_PREVENTIVO } from "./constants";
import { get, post, put, del } from "./service";

/**
 * Function to fetch all the preventivi with optional pagination.
 * @param {number} page_number - Optional page number (0, 1, 2...)
 * @param {number} elements_count - Optional elements per page
 */
export const getPreventivi = async (page_number, elements_count) => {
  let url = PREVENTIVI();
  if (page_number !== undefined && elements_count !== undefined) {
    url += `?page_number=${page_number}&elements_count=${elements_count}`;
  }
  return get(url);
};

export const getPreventiviFiltered = async (filters, page_number, elements_count) => {
  return post(PREVENTIVI_FILTERED(page_number, elements_count), filters);
};


export const deletePreventivo = async (id) => {
  return del(DELETE_PREVENTIVO(id));
};

export const sendMailPreventivo = async (mailPreventivo) => {
	return post(SEND_MAIL_PREVENTIVO(), mailPreventivo);
};

export const duplicatePreventivo = async (id) => {
  return post(DUPLICATE_PREVENTIVO(id));
};